import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'homeF',
    component: () => import(/* webpackChunkName: "homeF" */ '@/views/homeF.vue')
  },
  {
    path: '/catalog',
    name: 'productListF',
    component: () => import(/* webpackChunkName: "productListF" */ '@/views/productListF.vue')
  },
  {
    path: '/topup/:id',
    name: 'payCheckoutF',
    component: () => import(/* webpackChunkName: "payCheckoutF" */ '@/views/payCheckoutF.vue')
  },
  {
    path: '/mobile',
    name: 'mobileTopupF',
    component: () => import(/* webpackChunkName: "mobileTopupF" */ '@/views/mobileTopupF.vue')
  },
  {
    path: '/checkout/:gameId/:orderNo',
    name: 'payConfirmF',
    component: () => import(/* webpackChunkName: "payConfirmF" */ '@/views/payConfirmF.vue')
  },
  {
    path: '/payResult',
    name: 'payResultF',
    component: () => import(/* webpackChunkName: "payResultF" */ '@/views/payResultF.vue')
  },
  // 法务三页正文复用 A/B/C 共用组件，legalF 只负责 F 的排版与左侧目录
  {
    path: '/privacy',
    name: 'rprivacyF',
    meta: { doc: 'privacy' },
    component: () => import(/* webpackChunkName: "legalF" */ '@/views/legalF.vue')
  },
  {
    path: '/tos',
    name: 'reulaF',
    meta: { doc: 'tos' },
    component: () => import(/* webpackChunkName: "legalF" */ '@/views/legalF.vue')
  },
  {
    path: '/conduct',
    name: 'ractionF',
    meta: { doc: 'conduct' },
    component: () => import(/* webpackChunkName: "legalF" */ '@/views/legalF.vue')
  }
]

const routerF = new VueRouter({
  mode: 'history',
  base: process.env.BASF_URL,
  routes
})

export default routerF
